// utils/searchPatientByPhone.js
import axiosInstance from "./axiosInstance";

export const searchPatientByPhone = async (phone) => {
  const res = await axiosInstance.get(`/patients/search?phone=${phone}`);
  return res.data;
};
